import * as React from 'react';

function SvgOrderRate(props) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.229 12.153h-8.381V3.77a.188.188 0 00-.188-.187h-.61a9.341 9.341 0 00-6.62 2.742 9.327 9.327 0 00-2.742 6.623A9.34 9.34 0 004.43 19.57c.86.86 1.86 1.536 2.976 2.007 1.154.49 2.394.74 3.647.738a9.344 9.344 0 006.621-2.742 9.316 9.316 0 002.006-2.977c.49-1.153.74-2.394.739-3.647v-.609a.192.192 0 00-.19-.187zm2.06-1.301l-.06-.661a9.303 9.303 0 00-2.698-5.726 9.34 9.34 0 00-5.74-2.693l-.664-.06a.186.186 0 00-.204.184v8.993c0 .103.085.188.188.188l8.99-.024a.189.189 0 00.188-.201z"
        fill="#6B92F3"
      />
    </svg>
  );
}

export default SvgOrderRate;
